import React from 'react';
import { Bubble } from '@lt/components';

import styles from './hotelCardLabel.module.css';

type HotelCardLabelProps = {
  labelText: string;
  Icon?: React.ReactNode;
  tooltipText?: string;
};

const HotelCardLabel = (props: HotelCardLabelProps) => {
  const { labelText, Icon, tooltipText } = props;

  return (
    <Bubble
      className={styles.styledBubble}
      disabled={!tooltipText}
      text={tooltipText}
    >
      <div className={styles.label}>
        {Icon && <div className={styles.iconWrapper}>{Icon}</div>}
        <div className={styles.textWrapper}>{labelText}</div>
      </div>
    </Bubble>
  );
};

export default HotelCardLabel;
